import { useEffect, useRef, useState } from "react";

export const SIMON_BUTTONS = [
  { id: "red",    label: "🔴", color: "#FF3355", glow: "#FF335588" },
  { id: "blue",   label: "🔵", color: "#0088FF", glow: "#0088FF88" },
  { id: "yellow", label: "🟡", color: "#FFE600", glow: "#FFE60088" },
  { id: "green",  label: "🟢", color: "#00DD66", glow: "#00DD6688" },
];

export default function SimonHost({ simonData, tv }) {
  const fs = (a, b) => tv ? a : b;

  // simonData phases:
  //   phase: "show"    — currently showing sequence
  //   phase: "input"   — players are entering
  //   phase: "result"  — showing who failed
  //   phase: "eliminated" — someone just got eliminated
  // simonData fields: sequence, highlight_index, phase, round, eliminated, alive, scores, failed

  const phase         = simonData?.phase ?? "waiting";
  const sequence      = simonData?.sequence ?? [];
  const highlightIdx  = simonData?.highlight_index ?? -1;
  const round         = simonData?.round ?? 1;
  const eliminated    = simonData?.eliminated ?? [];
  const alive         = simonData?.alive ?? [];
  const scores        = simonData?.scores ?? {};
  const failed        = simonData?.failed ?? [];   // names who failed this round

  const activeBtn = highlightIdx >= 0 ? sequence[highlightIdx] : null;

  return (
    <div style={{
      width: "100%", maxWidth: "600px", margin: "0 auto",
      padding: fs("1.5rem 1rem", "0.75rem 0.5rem"),
      display: "flex", flexDirection: "column", gap: fs("1.2rem", "0.8rem"),
    }}>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{
          fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1.1rem", "0.85rem"),
          color: "#ffe600", background: "#ffe60011", border: "1.5px solid #ffe60044",
          borderRadius: "0.6rem", padding: "0.3rem 0.8rem",
        }}>
          ⚡ Раунд {round} · {sequence.length} {sequence.length === 1 ? "кнопка" : sequence.length < 5 ? "кнопки" : "кнопок"}
        </div>
        <div style={{
          fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1rem", "0.8rem"),
          color: "#3dffa0",
        }}>
          Живых: {alive.length}
        </div>
      </div>

      {/* Phase label */}
      <div style={{ textAlign: "center" }}>
        {phase === "show" && (
          <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1.3rem", "1rem"), color: "#fff" }}>
            👀 Запоминайте последовательность!
          </p>
        )}
        {phase === "input" && (
          <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1.3rem", "1rem"), color: "#3dffa0" }}>
            📱 Повторяйте на телефоне!
          </p>
        )}
        {phase === "result" && failed.length > 0 && (
          <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1.3rem", "1rem"), color: "#FF3355" }}>
            💀 Ошиблись: {failed.join(", ")}
          </p>
        )}
        {phase === "result" && failed.length === 0 && (
          <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: fs("1.3rem", "1rem"), color: "#3dffa0" }}>
            ✅ Все справились! Усложняем...
          </p>
        )}
      </div>

      {/* Buttons grid */}
      <div style={{
        display: "grid", gridTemplateColumns: "1fr 1fr",
        gap: fs("1rem", "0.6rem"),
      }}>
        {SIMON_BUTTONS.map(btn => {
          const isActive = activeBtn === btn.id;
          return (
            <div key={btn.id} style={{
              background: isActive ? btn.color : btn.color + "33",
              border: `3px solid ${btn.color}`,
              borderRadius: "1rem",
              height: fs("120px", "80px"),
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: fs("3rem", "2rem"),
              boxShadow: isActive ? `0 0 40px ${btn.glow}, 0 0 80px ${btn.glow}` : "none",
              transform: isActive ? "scale(1.05)" : "scale(1)",
              transition: "all 0.1s",
            }}>
              {btn.label}
            </div>
          );
        })}
      </div>



      {/* Players list */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", justifyContent: "center" }}>
        {[...alive, ...eliminated].map(name => {
          const isElim = eliminated.includes(name);
          const justFailed = failed.includes(name);
          return (
            <div key={name} style={{
              background: isElim ? "#200000" : justFailed ? "#3d0000" : "#110825",
              border: `2px solid ${isElim ? "#FF3355" : justFailed ? "#FF3355" : "#ffffff11"}`,
              borderRadius: "0.6rem", padding: "0.25rem 0.7rem",
              fontFamily: "'Fredoka One', sans-serif",
              fontSize: fs("0.9rem", "0.75rem"),
              color: isElim ? "#FF335566" : justFailed ? "#FF3355" : "#fff",
            }}>
              {isElim ? "💀 " : justFailed ? "❌ " : "✅ "}{name}

            </div>
          );
        })}
      </div>
    </div>
  );
}